import React from "react";
import PropTypes from "prop-types";

function MailClosed({ className, style, fill, defaultWidth, defaultHeight }) {
  return (
    <svg
      viewBox="0 0 22 16"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Desktop"
        stroke="none"
        stroke-width="1"
        fill={fill}
        fill-rule="evenodd"
      >
        <g
          id="5.-Confirm-Information"
          transform="translate(-420 -382)"
          fill="#000000"
          fill-rule="nonzero"
        >
          <g id="Group" transform="translate(420 382)">
            <path
              d="M20.066 0H1.934A1.94 1.94 0 000 1.941v11.647a1.94 1.94 0 001.934 1.941h18.132A1.94 1.94 0 0022 13.59V1.94A1.94 1.94 0 0020.066 0zm-.297 1.294l-8.27 8.33c-.252.253-.746.254-.998 0l-8.27-8.33h17.538zM1.29 13.35V2.18l5.546 5.585-5.546 5.585zm.942.885l5.514-5.554 1.843 1.856c.755.76 2.07.76 2.824 0l1.843-1.856 5.514 5.554H2.231zm18.48-.885l-5.546-5.585 5.546-5.586V13.35z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

MailClosed.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string
};

MailClosed.defaultProps = {
  className: undefined,
  defaultHeight: 16,
  defaultWidth: 22,
  fill: "none"
};

export default MailClosed;
